import type {App, Plugin} from 'vue';
import { configureValidation } from '@/validation/config';

export default {
    install(app: App): void {
        configureValidation();
    },
} as Plugin;
